import { FieldType } from '@/api/types';

export enum EditorViewMode {
    List = 'list',
    Grid = 'grid',
}

export enum FieldsPanelView {
    Default = 'default',
    // Text
    TextFieldEdit = 'text_field_edit',
    TextLayerEdit = 'text_layer_edit',
    TextLayerLink = 'text_layer_link',
    // Image
    ImageFieldEdit = 'image_field_edit',
    ImageLayerEdit = 'image_layer_edit',
    ImageLayerLink = 'image_layer_link',
}

export interface Graphic {
    svgContent: string;
    title: string;
    size: string;
}

export enum LayerType {
    Text = 'text',
    Image = 'image',
}

export interface LayerRect {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface TextLayerProps {
    text: string;
    fontSize: number;
    fontFamily: string;
    fontWeight: number;
    fontStyle: string;
    lineHeight: number;
    fill: string;
}

export interface ImageLayerProps { }

export type LayerProps = TextLayerProps | ImageLayerProps;

export interface Layer {
    id: string;
    type: LayerType;
    rect: LayerRect;
    props: LayerProps;
    variantId: number;
}

export function fieldToLayerType(fieldType: FieldType): LayerType {
    switch (fieldType) {
        case FieldType.Text:
            return LayerType.Text;
        case FieldType.Image:
            return LayerType.Image;
        default:
            throw new Error(`Unsupported field type: ${fieldType}`);
    }
}
